module.exports = __webpack_public_path__ + "img/2025-06-11c_3.d251d1b3.jpg";